const level = [
  [ 0,   0,   0,   0,   0,   0,   0,   0,   0,   0],
  [ 0,   0,   0,  99,  99,  99,  99,  99,   0,   0],
  [ 0,  99,  99,  99,   0,   0,   0,  99,   0,   0],
  [ 0,  99,  64,   7,   0,   9,  38,  99,   0,   0],
  [ 0,  99,   0,   0,   0,   0,   0,  99,   0,   0],
  [ 0,  99,  99,  99,  99,   0,  52,  99,   0,   0],
  [ 0,   0,   0,   0,  99,  99,  99,  99,   0,   0],
  [ 0,   0,   0,   0,   0,   0,   0,   0,   0,   0],

]

export default level